import { TRANSLATION_KEYS } from 'partner360/features/keyInitiatives/configs/translations'

import { ActionCardType, IAction } from '../models'

interface IGetActionCardsParams {
  isFinancialPlanCompleted: boolean
  isFinancialDataLoaded?: boolean
}

export const getActionCards = ({
  isFinancialPlanCompleted,
  isFinancialDataLoaded = true,
}: IGetActionCardsParams): IAction[] => {
  const cards: IAction[] = [
    {
      icon: 'kbase kbase-add',
      titleKey: TRANSLATION_KEYS.actionCards.createInitiative.title,
      descriptionKey: TRANSLATION_KEYS.actionCards.createInitiative.description,
      action: ActionCardType.CreateInitiative,
    },
    {
      icon: 'kbase kbase-copy',
      titleKey: TRANSLATION_KEYS.actionCards.clonePreviousYear.title,
      descriptionKey: TRANSLATION_KEYS.actionCards.clonePreviousYear.description,
      action: ActionCardType.ClonePreviousYear,
    },
  ]

  if (isFinancialDataLoaded && !isFinancialPlanCompleted) {
    return [
      {
        icon: 'kbase kbase-editor-add-table',
        titleKey: TRANSLATION_KEYS.actionCards.completeFinPlan.title,
        descriptionKey: TRANSLATION_KEYS.actionCards.completeFinPlan.description,
        action: ActionCardType.CompleteFinancialPlan,
        isHighlighted: true,
      },
      ...cards,
    ]
  }

  return cards
}
